export const GET_LIST_SALE_DEAL = `
query GetAllVoucher ($input:TvoucherWhereInput, $skip:Float, $take: Float) {
    getVoucher (where: $input, skip:$skip, take: $take) {
        pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
        }
        items {
            id
            voucherName
            channel
            saleOrg
            conditionType
            discountValue
            limitAmount
            minimumBill
            saleDeal
            saleDealName
            sdFromDate
            sdToDate
            status
            serial
            seriFromDate
            seriToDate
            tconditionType{
                id
                name
                tsGold
                tsItaly
                value
            }
            createDate
            modifyDate
            tcreateUser{
                fullName
            }
            tmodifyUser{
                fullName
            }
        }
    }
}`;

export const GET_LIST_SALE_DEAL_CB = `
query GetVoucherComboBox($input:TvoucherWhereInput,$skip:Float,$take:Float){
    getVoucher(where:$input,skip:$skip,take:$take,groupBy:[saleDeal,saleDealName]){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{   
            saleDeal
            saleDealName
        }
    }
}`;

export const GET_LIST_CONDITION_TYPE_CB = `
query GetConditionTypeComboBox($input:TconditionTypeWhereInput,$skip:Float,$take:Float){
    getConditionType(where:$input,skip:$skip,take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id                
            name
        }
    }
}`;
